import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';
import { KnowledgeBaseButtonStyleStates } from './types';

const styles = {
  root: css``,
  content: () =>
    css({
      cursor: 'pointer',
      gap: 4,
    }),
} satisfies Styles<KnowledgeBaseButtonStyleStates>;

export const useStyles = withStyles(styles);
